import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// ENVIRONEMNTS
import { environment } from '@app/env-service';

// INTERFACES
import { PaginationInterface } from './../../../interfaces/pagination.model';
import { AccountUserInterface } from './../../../modules/clients/interfaces/business-contacts.interface';

@Injectable({
  providedIn: 'root',
})
export class UserAccountsService {
  private readonly _currentUser = new BehaviorSubject<AccountUserInterface>(
    <AccountUserInterface>{},
  );
  private readonly _users = new BehaviorSubject<AccountUserInterface[]>(
    <AccountUserInterface[]>[],
  );
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _pagination = new BehaviorSubject<PaginationInterface>(
    <PaginationInterface>{},
  );

  currentUser$ = this._currentUser.asObservable();
  users$ = this._users.asObservable();
  loading$ = this._loading.asObservable();
  pagination$ = this._pagination.asObservable();

  url :string = environment.urlV2 + '/user-accounts';

  constructor(private http :HttpClient) {}

  get(params ?:{ [param :string] :string | string[] } | HttpParams) :Subscription {
    this._loading.next(true);

    // TODO: use url param serializer
    return this.http
      .get(
        `${this.url}?relations[]=businessAccountContacts.businessAccount&relations[]=salesRepAssignees&relations[]=tags`,
        { params },
      )
      .subscribe(
        (response :any) => {
          this._users.next(response.data);
          this._pagination.next(response.meta);
          this._loading.next(false);
        },
        (response :any) => throwError(response.error),
      );
  }

  update(params :{ id :number; payload :any }) :Observable<any> {
    const { id, payload } = params;

    return this.http.put(`${this.url}/${id}`, { ...payload }).pipe(
      map((response :any) => {
        return response;
      }),
      catchError((response) => {
        return throwError(response.error);
      }),
    );
  }

  delete(id :number) :Observable<any> {
    return this.http.delete(`${this.url}/${id}`).pipe(
      map((response :any) => {
        return response;
      }),
      catchError((response) => {
        return throwError(response.error);
      }),
    );
  }

  setCurrentUser(user :AccountUserInterface) :void {
    this._currentUser.next(user);
  }

  setUserFromUsers(user :AccountUserInterface) :void {
    const users = this._users.value.filter((u) => u.id !== user.id);
    this._users.next([...users, user]);
  }
}
